import { useCallback } from 'react';

import type { ButtonProps } from '@/_components';
import { Button } from '@/_components';
import { downloadFile, snackbar, useBoolean } from '@/_shared';

type DownloadButtonProps = ButtonProps & {
  fileSrc: string;
  fileName?: string;
};

export function DownloadButton({ fileSrc, fileName, ...props }: DownloadButtonProps) {
  const [isLoading, loading] = useBoolean();

  const download = useCallback(async () => {
    try {
      loading.setTrue();
      await downloadFile(fileSrc, fileName ?? 'download');
    } catch (e) {
      console.error(e);
      snackbar.error('Failed to download file');
    } finally {
      loading.setFalse();
    }
  }, [fileName, fileSrc, loading]);

  return <Button {...props} showLoader={isLoading} onClick={download} />;
}
